<template>
  <div class="exportAnnotation">
    <div style="height:100%;overflow-y: auto;">
      <div v-if="selectShow" class="select">
        <el-form ref="queryForm" :model="queryForm" label-position="left" size="small" :inline="true"
          label-width="100px">
          <el-form-item label="状态:">
            <el-checkbox-group v-model="queryForm.statusIdList">
              <el-checkbox v-for="(item, index) in dicList.statusList" :key="index" :label="item.id">
                {{ item.cnName }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="意见类型:">
            <el-checkbox-group v-model="queryForm.qmTypeIdList">
              <el-checkbox v-for="(item, index) in dicList.checkTypeList" :key="index" :label="item.id">
                {{ item.cnName }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="严重等级:">
            <el-checkbox-group v-model="queryForm.problemTypeIdList">
              <el-checkbox v-for="(item, index) in dicList.severityLevelList" :key="index" :label="item.id">
                {{ item.cnName }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="创建人:">
            <el-select v-model="queryForm.createUserIdList" :popper-append-to-body="false" placeholder="请选择创建人" multiple
              filterable>
              <el-option v-for="(item, index) in dicList.createUserList" :key="index" :label="item.name"
                :value="item.userId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="处理人:">
            <el-select v-model="queryForm.modifierIdList" :popper-append-to-body="false" placeholder="请选择处理人" multiple
              filterable>
              <el-option v-for="(item, index) in dicList.modifierList" :key="index" :label="item.name"
                :value="item.userId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="stageShow" label="阶段:">
            <el-select v-model="queryForm.stageIdList" multiple placeholder="请选择阶段">
              <el-option v-for="item in dicList.specStageChildVos.find(ele => ele.name == '阶段').optionalValues"
                :key="item.id"
                :label="item.cnName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="specShow" label="专业:">
            <el-select v-model="queryForm.specIdList" multiple placeholder="请选择专业">
              <el-option v-for="item in dicList.specStageChildVos.find(ele => ele.name == '专业').optionalValues"
                :key="item.id"
                :label="item.cnName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="multiSpecShow" label="跨专业:">
            <el-select v-model="queryForm.multiSpecList" multiple placeholder="请选择跨专业">
              <el-option v-for="item in dicList.specStageChildVos.find(ele => ele.name == '跨专业').optionalValues"
                :key="item.id" :label="item.cnName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="childShow" :label="`${$titles.child}:`">
            <el-select v-model="queryForm.stageChildIdList" multiple :placeholder="`请选择${$titles.child}`">
              <el-option
                v-for=" item in dicList.specStageChildVos.find(ele => ele.name == $titles.child).optionalValues "
                :key="item.id"
                :label="item.cnName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建开始时间:">
            <el-date-picker :key="startDateKey" ref="startDateRef" v-model="queryForm.startCreateTime"
              :picker-options="startDatePickerOptions" value-format="yyyy-MM-dd"
              type="date" placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="创建结束时间:">
            <el-date-picker :key="endDateKey" ref="endDateRef" v-model="queryForm.endCreateTime"
              :picker-options="endDatePickerOptions" value-format="yyyy-MM-dd"
              type="date" placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <div style="display: inline-block;">
            <el-form-item label="数据来源:" class="sourceStyle">
              <el-select v-model="queryForm.sourceList" placeholder="请选择数据来源" multiple size="small">
                <el-option v-for="(item, index) in dicList.problemSourceList" :key="index" :label="item.cnName"
                  :value="item.cnName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="sourceStyle">
              <el-button size="small" @click="chongzhi">重置</el-button>
              <el-button size="small" title="应用" type="primary" @click="sureSelect">查询</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="table">
        <el-table ref="multipleTable" :data="nolist" tooltip-effect="dark" style="width: 100%;min-height:400px" row-key="questionId" height="100%" border>
          <el-table-column show-overflow-tooltip prop="fileName" width="200" label="文件名称" align="center"></el-table-column>
          <el-table-column show-overflow-tooltip prop="checkContent" width="200" label="问题描述" align="center">
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="queStatus" label="问题状态" align="center"
            column-key="statusList">
            <template slot-scope="scope">
              <div>
                <span slot="reference" class="changeStatus" :class="{
                  status1: scope.row.queStatus == '待修改',
                  status2: scope.row.queStatus == '已修改',
                  status3: scope.row.queStatus == '已取消',
                  status4: scope.row.queStatus == '已复核',
                }
                ">
                  {{ scope.row.queStatus }}
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="problemType" label="严重等级" align="center"></el-table-column>
          <el-table-column show-overflow-tooltip prop="modifierName" label="修改人" align="center"
            column-key="modifierList">
            <template slot-scope="scope">
              <span>{{ modifierNames(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="qmType" label="意见类型" align="center"
            column-key="checkTypeList"></el-table-column>
          <el-table-column show-overflow-tooltip prop="stageChildName" :label="$titles.child" align="center"
            column-key="subItemList"></el-table-column>
          <el-table-column show-overflow-tooltip prop="specName" label="专业" align="center"
            column-key="specList"></el-table-column>
          <el-table-column show-overflow-tooltip prop="creatorName" label="创建人" align="center"
            column-key="createUserList">
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="createDate" label="创建时间" align="center"></el-table-column>
          <el-table-column show-overflow-tooltip prop="source" label="问题来源"
            align="center" column-key="problemSourceList"></el-table-column>
        </el-table>
      </div>
    </div>
    <div class="pagination">
      <el-pagination v-if="page.totalCount > 0" :current-page.sync="page.pageNo" :page-size="page.pageSize"
        :layout="page.pageLayout" :total="page.totalCount" size="small" background
        @current-change="currentChange" @size-change="handleSizeChange" />
    </div>
    <div class="footer">
      <el-button size="small" @click="cancelExportAnnotation">取 消</el-button>
      <el-button v-preventReClick size="small" type="primary" :disabled="nolist.length === 0" @click="exportList()">
        导出
      </el-button>
    </div>
  </div>
</template>

<script>
const queryFormParams = () => ({
  statusIdList: [], // 状态
  qmTypeIdList: [], // 意见类型
  problemTypeIdList: [], // 严重等级
  createUserIdList: [], // 创建人
  modifierIdList: [], // 处理人
  stageIdList: [], // 阶段
  specIdList: [], // 专业
  multiSpecList: [], // 跨专业
  stageChildIdList: [], // 子项
  startCreateTime: "", // 创建开始时间
  endCreateTime: "", // 创建结束时间
  sourceList: [] // 数据来源
});
import mongeService from "@/CommonDP/mongeView/service/monge-service";
import docService from "@/CommonDP/service/doc-service";
import { mapState } from "vuex";

export default {
  props: {
    currentRow: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      queryForm: queryFormParams(),
      prjID: '',
      nolist: [],
      dicList: [],
      stageShow: false,
      specShow: false,
      childShow: false,
      multiSpecShow: false,
      selectShow: false,
      page: {
        pageNo: 1,
        pageSize: 20,
        totalCount: 0,
        pageLayout: "total,sizes,prev, pager, next,jumper" // 分页组件
      },
      isFolder: 1,
      id: '',
      startDateKey: 0,
      endDateKey: 0,
      startDatePickerOptions: {},
      endDatePickerOptions: {}
    };
  },
  computed: {
    ...mapState({
      prjInfo: (state) => state.projectMg.prjObj
    }),
    queryParams() {
      const params = {
        ...this.queryForm,
        startCreateTime: this.queryForm.startCreateTime ? this.queryForm.startCreateTime + " 00:00:00" : this.queryForm.startCreateTime,
        endCreateTime: this.queryForm.endCreateTime ? this.queryForm.endCreateTime + " 00:00:00" : this.queryForm.endCreateTime,
        prjId: this.prjID,
        fileId: this.isFolder == 1 ? '' : this.id,
        folderId: this.isFolder == 1 ? this.id : '',
        pageNum: this.page.pageNo,
        pageSize: this.page.pageSize,
        sortType: "1",
        keyword: ''
      };
      return params;
    }
  },
  watch: {
    "queryForm.startCreateTime"(newValue, oldValue) {
      this.endDateKey = new Date().getTime();
      if (!this.$refs.endDateRef) return null;
      if (newValue === null) {
        this.queryForm.startCreateTime = "";
      }
      this.$refs.endDateRef.pickerOptions.disabledDate = (time) => {
        return new Date(this.queryForm.startCreateTime).getTime() > time.getTime() + 8.64e7;
      };
    },

    "queryForm.endCreateTime"(newValue, oldValue) {
      this.startDateKey = new Date().getTime();
      if (!this.$refs.startDateRef) return null;
      if (newValue === null) {
        this.queryForm.endCreateTime = "";
      }
      this.$refs.startDateRef.pickerOptions.disabledDate = (time) => {
        return time.getTime() > new Date(this.queryForm.endCreateTime).getTime();
      };
    }
  },
  mounted() {
    this.prjID = this.$route.query.prjId || this.prjInfo.prjId;
    this.isFolder = this.$route.query.isFolder || this.currentRow.isFolder;
    this.id = this.$route.query.id || this.currentRow.folderId ;
    this.queryDic();
  },
  methods: {
    // 查询时候的字典
    async queryDic() {
      const res = await mongeService.getFilterDic(this.prjID);
      this.dicList = res.data || {};
      this.selectShow = true;
      this.stageShow = this.dicList.specStageChildVos.some(ele => ele.name === '阶段');
      this.specShow = this.dicList.specStageChildVos.some(ele => ele.name === '专业');
      this.childShow = this.dicList.specStageChildVos.some(ele => ele.name === this.$titles.child);
      this.multiSpecShow = this.dicList.specStageChildVos.some(ele => ele.name === '跨专业');
    },
    // 重置按钮
    chongzhi() {
      this.queryForm = queryFormParams();
      this.page.pageNo = 1;
      this.nolist = [];
      this.queryNotationList();
    },
    // 查询按钮
    sureSelect() {
      this.page.pageNo = 1;
      this.nolist = [];
      this.queryNotationList();
    },
    // 查询列表接口
    async queryNotationList() {
      this.nolist = [];
      try {
        const res = await docService.queryAnnotationList(this.queryParams);
        this.nolist = res.data;
        this.page.totalCount = res.totalCount;
      } catch (error) {
        console.log(error, 'error');
      }
    },
    // 修改人
    modifierNames(row) {
      const names = [];
      if (row.modifierList && row.modifierList.length > 0) {
        row.modifierList.forEach((ele) => {
          names.push(ele.modifierName);
        });
      }
      return names.join(",");
    },
    handleSizeChange(val) {
      this.page.pageNo = 1;
      this.page.pageSize = val;
      this.nolist = [];
      this.queryNotationList();
    },
    currentChange(val) {
      this.page.pageNo = val;
      this.nolist = [];
      this.queryNotationList();
    },
    async exportList() {
      const res = await docService.exportAnnotationList(this.queryParams);
      const fileName = '批注列表导出' + ".xlsx";
      if ("msSaveOrOpenBlob" in navigator) {
        // 兼容ie
        window.navigator.msSaveOrOpenBlob(res, fileName);
        return;
      } else {
        const link = document.createElement("a");
        const blob = res;
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", decodeURI(fileName));
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
    async cancelExportAnnotation() {
      this.selectShow = false;
      if (this.$route.query.prjId) {
        await CefSharp.BindObjectAsync("cefSharpBrower");
        cefSharpBrower.closeWindow();
      } else {
        this.$emit('callback');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.exportAnnotation {
  height: 100%;
  position: relative;
  padding-bottom: 93px;

  .select {
    padding: 15px;

    .el-form-item {
      margin-right: 20px
    }

    .el-checkbox {
      margin-right: 10px;

      /deep/.el-checkbox__label {
        padding-left: 2px;
      }
    }

    /deep/ .el-form-item__content {
      width: 281px;
    }

    /deep/ .el-input {
      width: 281px;
    }

    .sourceStyle {
      /deep/ .el-form-item__content {
        width: 132px;
      }

      /deep/ .el-input {
        width: 132px;
      }
    }
  }

  .table {
    padding: 0 15px;
    height: calc(100% - 219px);
    min-height: 410px
  }

  .changeStatus {
    padding: 5px 10px;
    border-radius: 4px;
  }

  .status1 {
    background: #fce9df;
    color: #eb5757;
  }
  .status2 {
    background: #ffffdf;
    color: #eac100;
  }
  .status3 {
    background: #f2f2f2;
    color: #8b8888;
  }
  .status4 {
    background: #def6e4;
    color: #00b632;
  }

  .pagination {
    text-align: right;
    position: absolute;
    bottom: 50px;
    right: 0px;
    left: 0;
    padding: 5px 15px 5px 0;
    height: 42px;
  }

  .footer {
    text-align: right;
    position: absolute;
    bottom: 10px;
    bottom: 0px;
    right: 0px;
    left: 0;
    padding: 5px 15px 5px 0;
    border-top: 1px solid #2e5bff1a;
  }
}
</style>
